import { Component } from "@kluntje/core";
import SSOService, { UserObject } from "Services/SSOService";

/**
 * Custom Element to load content based on users login state
 */
class FRAProtectedContainer extends Component {
  SSOService = SSOService.getInstance();

  constructor() {
    super({
      props: {
        // show content only when the user is logged in or logged out. default is show regardless the login state
        showWhen: {
          type: "string",
          required: false,
        },
        // after user successfully logged in,
        // protected content will be loaded from this URL
        ajaxUrl: {
          type: "string",
          required: false,
        },
      },
    });

    this.onAuthChange = this.onAuthChange.bind(this);
  }

  /**
   * @override
   */
  afterComponentRender() {
    // show screen/content depending on the login state
    if (this.showWhen) {
      // this.onAuthChange(this.SSOService.loggedIn);
      this.SSOService.subscribe(this.onAuthChange);
    }
  }

  // show hide login screen, load content / redirect to target page on login
  onAuthChange({ loggedIn, user }: { loggedIn: boolean; user: UserObject | null }) {
    // SSO state match
    this.replaceChildren();
    if ((this.showWhen === "LOGGED-IN" && loggedIn) || (this.showWhen === "LOGGED-OUT" && !loggedIn)) {
      if (this.ajaxUrl) this.fetchContent(loggedIn, user);
    }
  }

  // loads protected content
  async fetchContent(loggedIn: boolean, user: UserObject | null) {
    const resp = await fetch(this.ajaxUrl);
    let markup = await resp.text();

    markup = markup.replaceAll("{USER_FIRST_NAME}", loggedIn ? user!.firstName : "");
    markup = markup.replaceAll("{USER_LAST_NAME}", loggedIn ? user!.lastName : "");

    this.innerHTML = markup;

    const scriptTags = this.querySelectorAll("script");
    scriptTags.forEach(function (script) {
      const newScript = document.createElement("script");
      newScript.type = script.type;
      newScript.src = script.src.concat(script.src.includes("?") ? "&lateinit=immediate" : "?lateinit=immediate");

      if (script.parentNode) {
        script.parentNode.insertBefore(newScript, script);
        script.parentNode.removeChild(script);
      }
    });
  }
}

customElements.define("fra-m-protected-container", FRAProtectedContainer);

export default FRAProtectedContainer;
